var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLawIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#173CBA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M337.3,144.6c0,6.6-2.6,12.9-7.3,17.6l-3.2,3.2c-4.7,4.7-11,7.3-17.6,7.3c-6.6,0-12.8-2.6-17.5-7.3l-71-71 c-9.7-9.7-9.7-25.4,0-35l3.2-3.2c9.4-9.4,25.7-9.4,35,0l71,71C334.7,131.8,337.3,137.9,337.3,144.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.6,301.6l-3.2,3.2c-4.7,4.7-10.9,7.3-17.5,7.3c-6.6,0-12.9-2.5-17.5-7.3l-71-71 c-9.7-9.7-9.7-25.4,0-35.1l3.2-3.2c9.4-9.4,25.7-9.4,35.1,0l71,71C200.3,276.1,200.3,291.9,190.6,301.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.8,174.5c-26.5,16-56.1,43.5-82.2,84.2c-0.3-0.4-0.6-0.8-1-1.1l-71-71c-0.3-0.3-0.7-0.7-1.1-1 c48.6-31.2,73.1-63.7,84.2-82.2L282.8,174.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M302.8,245.7l-31.9,31.9l-39.7-39.8c10.8-13.4,21.3-24.1,31.1-32.5L302.8,245.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463.1,403.8c0,9-3.6,17.6-10,24c-6.4,6.4-15,10-24,10c-0.1,0-0.1,0-0.1,0c-9,0-17.6-3.6-24-10L276.3,299.1 c-2.5-2.5-2.5-6.5,0-9l39.1-39.1c2.5-2.5,6.5-2.5,9,0l128.7,128.7C459.5,386.2,463.1,394.7,463.1,403.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285.8,421.3v35.3c0,3.5-2.9,6.4-6.4,6.4H55.3c-3.6,0-6.4-2.9-6.4-6.4v-35.3c0-11.7,9.5-21.2,21.2-21.2 h194.5C276.2,400.1,285.8,409.6,285.8,421.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263.4,378.6v8.7H71.3v-8.7c0-11.7,9.5-21.2,21.2-21.2h149.7C253.8,357.4,263.4,366.9,263.4,378.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLawIcon);
export default __webpack_public_path__ + "static/media/law-icon.01fff8d1f4eb0cad8dc493e2e09bbf7e.svg";
export { ForwardRef as ReactComponent };